<div class="sig-wrap">
    <canvas #canvas class="sig-canvas"></canvas>

    <div class="actions">
        <button type="button" (click)="clear()">Effacer</button>
    </div>
</div>